if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.quickViewSlider = null;
      }

      hide(preventFocus = false) {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);

        if (this.quickViewSlider) {
          this.quickViewSlider.destroy(true, true);
          this.quickViewSlider = null;
        }

        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");

        const productURL = opener.getAttribute("data-product-url");

        if (opener.querySelector(".loading-overlay__spinner")) {
          opener
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
        }

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'div[id^="MainProduct-"]'
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(
              this.modalContent,
              this.productElement.innerHTML,
              opener
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");

            if (opener.querySelector(".loading-overlay__spinner")) {
              opener
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
            }

            const sliderElement = this.modalContent.querySelector(
              ".quick-js-media-list"
            );
            const sliderContainer = sliderElement
              ? sliderElement.closest(".quick-product__media-list")
              : null;

            if (sliderElement && sliderContainer) {
              this.quickViewSlider?.destroy(true, true);
              sliderElement.swiper?.destroy(true, true);

              this.quickViewSlider = new Swiper(sliderElement, {
                slidesPerView: 1,
                autoHeight: true,
                navigation: {
                  nextEl: sliderContainer.querySelector(".swiper-btn--next"),
                  prevEl: sliderContainer.querySelector(".swiper-btn--prev"),
                },
                pagination: {
                  el: sliderContainer.querySelector(".swiper-pagination"),
                  type: "fraction",
                  formatFractionCurrent: (number) => `0${number}`.slice(-2),
                  formatFractionTotal: (number) => `0${number}`.slice(-2),
                },
                on: {
                  slideChange: function () {
                    window.pauseAllMedia();
                  },
                },
              });
            }

            window.initVariantDropdowns?.();
          });
      }

      setInnerHTML(element, html, opener) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        // Read more button
        const moreBtn = document.createElement("a");
        moreBtn.innerHTML = `<span class="button-label">${theme.quickviewMore}</span>`;
        moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
        moreBtn.setAttribute(
          "class",
          "product__read-more button button--simple"
        );
        element.querySelector(".product__info-container").appendChild(moreBtn);
      }

      removeDOMElements(scopeElement = this.productElement) {
        if (!scopeElement) return;

        const pickupAvailability = scopeElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = scopeElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const popup = scopeElement.querySelectorAll(".product-popup");
        if (popup)
          popup.forEach((el) => {
            el.remove();
          });

        const reviews = scopeElement.querySelector(
          '[data-block-handle="reviews"]'
        );
        if (reviews) reviews.remove();

        const about = scopeElement.querySelectorAll(".product-about");
        if (about)
          about.forEach((el) => {
            el.remove();
          });

        const description = scopeElement.querySelector(
          ".main-product-description-block"
        );
        if (description) description.remove();
        const recommendations = scopeElement.querySelector(
          ".product-recommendations--single"
        );
        if (recommendations) recommendations.remove();

        const gift = scopeElement.querySelector(".customer");
        if (gift) gift.remove();
        const leftWrapper = scopeElement.querySelector(
          ".product__left-wrapper"
        );
        if (leftWrapper) leftWrapper.remove();

        const subSlider = scopeElement.querySelector(".product__media-sublist");
        if (subSlider) subSlider.remove();

        const inventory = scopeElement.querySelector(".product__inventory");
        if (inventory) inventory.remove();

        const productText = scopeElement.querySelector(".product__text");
        if (productText) productText.remove();

        const sizeGuide = scopeElement.querySelector(".adv-btn-opener");
        if (sizeGuide) sizeGuide.remove();

        const mediaScroll = scopeElement.querySelector(
          ".product__media-scroll-wrapper"
        );
        if (mediaScroll) mediaScroll.remove();
        const mediaSlider = scopeElement.querySelector(
          ".product__media-list-wrapper"
        );
        if (mediaSlider) mediaSlider.remove();
        const mediaGrid = scopeElement.querySelector(
          ".product__media-list__container--large-default"
        );
        if (mediaGrid) mediaGrid.remove();

        const mediaHorizontal = scopeElement.querySelector(
          ".product__media-list-wrapper-horizontal"
        );
        if (mediaHorizontal) mediaHorizontal.remove();

        const mediaHorizontalSecodary = scopeElement.querySelector(
          ".product__media-list-wrapper-horizontal.secondary"
        );
        if (mediaHorizontalSecodary) mediaHorizontalSecodary.remove();

        const mediaQuick = scopeElement.querySelector(
          ".quick-product__media-list"
        );
        if (mediaQuick) {
          mediaQuick.style.display = "block";
        }
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios")
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      preventVariantURLSwitching() {
        if (this.modalContent.querySelector("variant-radios,variant-selects")) {
          this.modalContent
            .querySelector("variant-radios,variant-selects")
            .setAttribute("data-update-url", "false");
        }
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }
    }
  );
}
